import { styled } from "styled-components";

export const StyledFinalH1 = styled.h1`
  font-weight: 600;
  color: var(--catalina-blue);
  font-size: 36px;
  position: relative;
  top: 50px;
`;

export const StyledText = styled.p`
  font-weight: 500;
  font-size: 20px;
  text-align: start;
  margin: 10px 3.7rem;
  align-self: center;
  position: relative;
  top: 60px;
`;

export const StyledFinalContainer = styled.div`
  text-align: center;
  height: 70vh;
  min-height: 600px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  place-content: center;
  place-items: center;
  background: var(--white);
`;
export const FinalIcon = styled.img``;
